import { render, staticRenderFns } from "./RegistryPage.vue?vue&type=template&id=62f41978&"
import script from "./RegistryPage.vue?vue&type=script&lang=js&"
export * from "./RegistryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports